import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../ui-components/shared.module';
import { ModalAiActionsButtonsComponent } from './modal-ai-actions-buttons/modal-ai-actions-buttons.component';
import { Router } from '@angular/router';
import { BaseToastComponent } from '../../ui-components/toast-popup/base-toast-component';
import { AiChatbotComponent } from '../../@components/ai/ai-chatbot/ai-chatbot.component';
import RoutesConstants from '../../constants/routes.constants';

@Component({
  selector: 'vw-menu-ai-actions-toast',
  imports: [
    SharedModule,
    ModalAiActionsButtonsComponent,
    AiChatbotComponent,
  ],
  templateUrl: './menu-ai-actions-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu-ai-actions-toast.component.scss',
})
export class MenuAiActionsToastComponent
  extends BaseToastComponent
  implements OnChanges
{
  inputIsFocus = false;

  /** Place de la barre d'onglets posée sur la feuille, en pixels : les actions se calent au-dessus. */
  @Input() barSpace = 0;

  @Output() inputFocus = new EventEmitter<void>();
  @Output() inputBlur = new EventEmitter<void>();

  @ViewChild(AiChatbotComponent) chatbot?: AiChatbotComponent;

  constructor(private router: Router) {
    super();
  }

  /** À chaque ouverture, Willy relit son décompte du jour. */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']?.currentValue && !changes['isOpen'].firstChange) {
      this.chatbot?.onOpened();
    }
  }

  onScanBarcode() {
    this.router.navigate([RoutesConstants.USER_ADD_SEED_SCAN]);
  }
  onAddPlant() {
    this.router.navigate([RoutesConstants.GARDEN_ADDPLANT]);
  }

  onShowTasks() {
    this.router.navigate([RoutesConstants.AGENDA_TASKS]);
  }

  onInputFocus() {
    this.inputIsFocus = true;
    this.inputFocus.emit();
  }

  onInputBlur() {
    this.inputIsFocus = false;
    this.inputBlur.emit();
  }
}
